export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/12-12.7f3ec927.gif","height":500,"width":500,"blurWidth":0,"blurHeight":0};